// extracted by mini-css-extract-plugin
module.exports = {"skeletonCheckContainer":"classes_skeletonCheckContainer__29GfU","skeletonCheck":"classes_skeletonCheck__3sAR6"};